export enum WidgetViewTypesEnum {
    None = 0,
    Number = 1,
    Table = 2,
    LineChart = 3,
    BarChart = 4,
    PieChart = 5,
    RadarChart = 6,
    TimeLineChart = 7,
    HeatGridChart = 8,
    ColumnChart = 9,
    StackedChart = 10,
    InstallationSummaryCard = 11,
    InstallationsStatusChangesTable = 12,
}
